import { type FunctionComponent, useState } from "react";
import {
  CalendarCheckIcon,
  CircleExclamationIcon,
  PaperPlaneIcon,
} from "@App/Components/common/Icons";
import { useTranslation } from "react-i18next";

type BookingTypeProps = {
  liveBookable: boolean;
  mobileVisible?: boolean;
};
export const BookingType: FunctionComponent<BookingTypeProps> = ({
  liveBookable,
  mobileVisible,
}: BookingTypeProps) => {
  const { t } = useTranslation(); // i18next
  const [showBookingHint, setShowBookingHint] = useState(false);

  return (
    <div className={"relative"}>
      <div
        className={`${mobileVisible ? "flex" : "hidden lg:flex"} text-sm xl:text-base items-center font-bold`}
      >
        {liveBookable ? (
          <>
            <CalendarCheckIcon
              className={`${mobileVisible ? "block" : "hidden lg:block"} h-4 w-4 mr-1`}
            />
            Sofort buchbar
          </>
        ) : (
          <>
            <PaperPlaneIcon
              className={`${mobileVisible ? "block" : "hidden lg:block"} h-4 w-5 mr-1`}
            />
            Terminanfrage
          </>
        )}
        <span
          className={`${mobileVisible ? "block" : "hidden lg:block"} ml-1 cursor-pointer`}
          onClick={() => setShowBookingHint(!showBookingHint)}
        >
          <CircleExclamationIcon className={"h-4 w-5"} />
        </span>
      </div>
      {showBookingHint && (
        <span
          className={
            "absolute text-sm text-neutral-700 rounded-md w-[225px] top-6 right-0 xl:top-0 xl:-right-[230px] border-2 border-neutral-100 bg-white z-20 cursor-pointer p-2"
          }
          onClick={() => setShowBookingHint(false)}
        >
          {liveBookable
            ? t("booking.moreInformation.instant-booking")
            : t("booking.moreInformation.request-booking")}
        </span>
      )}
    </div>
  );
};
